// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const StoneCategoryTranslationFragmentDoc = `
    fragment stoneCategoryTranslation on StoneCategoryTranslation {
  name
}
    `;